import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-300/40">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
                悟
              </div>
              <span className="text-xl font-heading font-bold text-foreground-950">
                悟空影视
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              悟空影视电影大全涵盖最新电影、动作片、喜剧片等海量题材。高清画质免费在线观看，即点即播。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              电影分类
            </h3>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              快速链接
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/category/kehuan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  科幻大片
                </Link>
              </li>
              <li>
                <Link to="/category/dongzuo" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  动作猛片
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              联系方式
            </h3>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-600">邮箱：service@wukongmovies.com</li>
              <li className="text-sm text-foreground-600">微信：悟空影视官方</li>
              <li className="text-sm text-foreground-600">微博：@悟空影视</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 悟空影视 WukongMovies. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}